import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import appConfig from '../config'
import Cookie from 'js-cookie'
import store from '@/store'
import iView from 'iview'
import types from '@/store/types'
import VueRouter from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'

/**
 * @description 验证是否在白名单
 * @param {String} path
 */
function inWhitList (path) {
  return (
    appConfig &&
    appConfig.router &&
    appConfig.router.whiteList &&
    appConfig.router.whiteList.indexOf(path) !== -1
  )
}

/**
 * @description 验证是否存在该路由的权限
 * @param {String} to 前往路由
 * @param {Array} auths 权限列表
 */
function auth (to, auths = []) {
  let path = to.path
  for (let i = 0; i < auths.length; ++i) {
    let isPass = false
    let child = auths[i][appConfig.router.childrenKey]
    // 本身路由不存在
    if (!auths[i][appConfig.router.urlKey] && child) {
      let pass = auth(to, child)
      if (pass) return true
      continue
    }
    // 如果直接相等则不需要分段校验
    if (path === auths[i][appConfig.router.urlKey]) return true
    // 分段校验
    let paths = path.split('/').filter(item => !!item)
    let params = {}
    let authPaths = auths[i][appConfig.router.urlKey]
      .split('/')
      .filter(item => !!item)
    for (
      let j = 0;
      paths.length === authPaths.length && j < paths.length;
      ++j
    ) {
      if (paths[j] !== authPaths[j]) {
        let paramMatcher = authPaths[j].match(/^\{(\w+)\}$/)
        if (paramMatcher && paramMatcher.length) {
          // 路由参数赋值
          params[paramMatcher[1]] = decodeURIComponent(paths[j])
          isPass = true
        } else {
          isPass = false
          break
        }
      } else isPass = true
    }
    if (isPass) {
      // 路由参数从此处获取
      to.meta.params = params
      return true
    } else if (child) {
      let pass = auth(to, child)
      if (pass) return true
    }
  }
  return false
}
// const formatRouter = (routes, newRoutes = []) => {
//   routes.map(item => {
//     if (item.children && item.children.length > 0) formatRouter(item.children, newRoutes)
//     if (item.meta.notCache) newRoutes.push(item)
//   })
//   return newRoutes
// }
// let flatRoutes = formatRouter(routes)
// router.addRoutes(flatRoutes)

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  let tokenKey = appConfig.cookie.TOKEN
  let token = Cookie.get(tokenKey)
  if (to.meta.noAuth && to.name !== LOGIN_PAGE_NAME) {
    // store.dispatch(types.user.GET_USER_INFO).then(() => next()).catch(() => next())
    // 不需要权限的页面 错误页
    next()
    return
  }
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: 'home' // 跳转到home页
    })
  } else {
    store
      .dispatch(types.user.GET_USER_INFO)
      .then(user => {
        if (!user) {
          // 未拉取到用户信息，注销跳转到登录页面
          Vue.prototype
            .$api('base/logout')()
            .then(() => {
              router.replace({ path: '/login' })
              next({ name: LOGIN_PAGE_NAME })
            })
          return
        }
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        if (
          inWhitList(to.path) ||
          auth(
            to,
            user[appConfig.router.routesKey]
              ? user[appConfig.router.routesKey]
              : []
          )
        ) {
          // 有权限，可访问
          next()
        } else {
          next({
            replace: true,
            name: 'error_401',
            query: { from: encodeURIComponent(from.fullPath) }
          }) // 无权限，重定向到401页面
        }
      })
      .catch(err => {
        // TODO 错误处理 看具体需求 超时应该不作处理
        // console.error(err)
        if (err.code === 504) {
          Vue.prototype.$notify.error({
            title: '错误',
            message: '请求超时',
            duration: 3000
          })
        } else if (err.code === 500) {
          Vue.prototype.$notify.error({
            title: '错误',
            message: (err.data && err.data.msg) || err.msg,
            duration: 3000
          })
        }
        iView.LoadingBar.finish()
      })
  }
})

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    // router.replace(targetPath)
    window.reload()
  }
})

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.afterEach(to => {
  iView.LoadingBar.finish()
  // 设置当前模块
  let matcher = to.path.match(/\/(\w+)(\/\w+)?/)
  if (matcher && matcher.length >= 2) {
    let module = appConfig.modules[matcher[1].toUpperCase()]
    if (!module) {
      // 取不到数据则使用默认的运营模块
      module = appConfig.modules.OM
    }
    store.dispatch('setModule', module)
    // 设置首页
    store.dispatch('setHomeTagNav', module.meta) // 首页是不需要传递参数的
  }
  // 设置首页
  // if (to.meta.home) {
  //   let {meta, name, path, params, fullPath} = to
  //   store.dispatch('setHomeTagNav', {
  //     meta,
  //     name,
  //     path,
  //     params,
  //     fullPath
  //   })
  // }
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js